import axios from 'axios'

export const urls = {
  zipCodes: '/api/zip-codes',
}

export const getCityZipCode = zipCode => {
  return axios.get(`${urls.zipCodes}?filter%5Bsearch%5D=${zipCode}`)
}
